export default __webpack_public_path__ + "static/documentation-365b847a8cd156271f59b1518ccb623c.svg";